import 'app/init-polyfills/array-from';
import objectAssign from 'object-assign';
import {Promise} from 'es6-promise';

if (! window.hasOwnProperty('Promise')) {
    window.Promise = Promise;
}

if (! Object.hasOwnProperty('assign')) {
    Object.assign = objectAssign;
}
